import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "@/routes";
import "@/styles/global.css";
import "@/styles/tailwind.css";

/**
 * React entry (B4). index.html references this file (#root mount).
 * Env-safe: no module here throws when .env is absent — Supabase is lazy.
 */
const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("[main] #root element not found in index.html");
}

createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
